import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IOpportunity } from "../opportunityModel";
import moment from "moment";

export const getAllOpportunities = createAsyncThunk(
  "Opportunity/OpportunityFindAll",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Opportunity/OpportunityFindAll`,
        {
          SetPriority: "",
        }
      );
      //   return response.data?.Data;
      if (response?.data?.Status === 200) {
        // SuccessToast(response.data?.Details || "Success");
        return response.data?.Data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching Opportunity:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createOpportunity = createAsyncThunk(
  "Opportunity/OpportunityInsert",
  async (Opportunity: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Opportunity/OpportunityInsert`,
        Opportunity
      );
      if (response.data?.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Inserting Opportunity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateOpportunity = createAsyncThunk(
  "Opportunity/OpportunityUpdate",
  async (Opportunity: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Opportunity/OpportunityUpdate`,
        Opportunity
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Opportunity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getOpportunityById = createAsyncThunk(
  "Opportunity/OpportunityFindByID",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Opportunity/OpportunityFindByID`,
        {
          OpportunityGUID: ID,
        }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        OpportunityGUID: result.OpportunityGUID,
        AddCustomerID: result?.AddCustomerID,
        OpportunityTypeID: result?.OpportunityTypeID,
        ExpectedValue: result?.ExpectedValue,
        SetPriority: result?.SetPriority,
        FollowupDate: result?.FollowupDate
          ? moment(result?.FollowupDate, "YYYY-MM-DD")?.toDate()
          : "",
        AssignTeamID: result?.AssignTeamID,
        client_options: result?.client_options || [],
        IsActive: result.IsActive === true ? 1 : 2,
      } as IOpportunity;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Opportunity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteOpportunity = createAsyncThunk(
  "Opportunity/OpportunityDelete",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Opportunity/OpportunityDelete`,
        {
          OpportunityGUID: ID,
        }
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Opportunity :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
